<template>
  <div @contextmenu.prevent="handler($event)"
       :id="this.id"
       class="sitebuilder-element-container big-is-receiver"
       element="VideoGalleryGroupComponent"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile"
       :config-properties="JSON.stringify(internal_config)"
       :style="style()"
       :key="keyComponent"
       v-on:click="focusElement($event)">

    <vue-draggable-resizable v-bind:w="parseInt(internal_config.width)"
                             @resizing="onResize"
                             :draggable="false" :enable-native-drag="true">

      <sync-drag :target="this"/>

      <options-element-bar ref="optionsBar" :elem="this"
                           name='ct-component-VideoGalleryGroupComponent'>
        <img src="static/images/icons/engrenagem.svg"
             v-tooltip="{content:$t('ct-config-videos'),  class: 'tooltip-custom'}"
             class="svg-icon normal-action"
             @click="openEdition"/>
      </options-element-bar>

      <div v-for="(category, index) in internal_config.tree" :key="index" :class="'container-fluid carrousel-'+index "
           v-bind:style="{
              background: background,
              paddingTop : paddingTop + '!important',
              paddingLeft : paddingLeft + '!important',
              paddingRight : paddingRight + '!important',
              paddingBottom : paddingBottom + '!important',
              borderRadius: radius,
              border : border,
              boxShadow: boxShadow
              }">
        <p class="clean-text-css" :style="textStyle()">{{category.name}}</p>
        <div id="myCarousel" class="carousel slide" data-ride="carousel" data-interval="9000">
          <div class="carousel-inner" role="listbox" v-bind:style="{height : heightTop}">
            <div v-for="(video, indexVideo) in category.childs"
                 :class="'item ' + (indexVideo == 0 ?'active':'')"
                 :url="video.url" :key="indexVideo">
              <div class="element-item" :data-id="video.id">
                <a href="#" v-bind:style="{height: heightTop}">
                  <img class="place-img" :src="video.thumbnail" v-bind:style="{maxHeight: heightTopImg}" loading="lazy">
                </a>
              </div>
            </div>
          </div>
          <!-- Controls -->
          <a class="left carousel-control" v-bind:style="{height : heightTop}" href="#myCarousel" role="button"
             data-slide="prev" @click="prev(index)" v-show="showArrow(category.childs)">
            <span class="mdi mdi-chevron-left" aria-hidden="true"
                  :style="{color:arrowColor, fontSize : arrowSize}"></span>
          </a>
          <a class="right carousel-control" v-bind:style="{height : heightTop}" href="#myCarousel" role="button"
             data-slide="next" @click="next(index)" v-show="showArrow(category.childs)">
            <span class="mdi mdi-chevron-right" aria-hidden="true"
                  :style="{color:arrowColor, fontSize : arrowSize}"></span>
          </a>
          <div class="container-gallery-video" v-bind:style="{height : height}" :data-id="dataId">
            <div v-for="(video, indexVideo) in category.childs" :key="indexVideo">
              <component v-for="(element,index) in elements" :is="element.name" :config="element.config" :key="index"
                         v-if="video.id == element.id"
                         :id="element.id" :height_start="index" :preview="preview" :childs="element.childs"
                         :style="styleApp()"
                         @setCallbackChangeDevice="setCallbackChangeDevice">
              </component>
            </div>
          </div>
        </div>
      </div>
    </vue-draggable-resizable>
    <resources ref="resourcesData"></resources>
  </div>
</template>

<script>

  import Data from './Model';
  import Resources from './Resources.vue';
  import OptionsElementBar from '../../OptionsElementBar';

  export default {
    name: 'VideoGalleryGroupComponent',
    props: ['config', 'childs', 'device', 'id', 'preview'],
    components: {
      OptionsElementBar,
      Resources
    },
    computed: {
      arrowColor() {
        return this.internal_config.arrowColor;
      },
      arrowSize() {
        return parseInt(this.internal_config.arrowSize) + 'px';
      },
      dataId() {
        return this.id
      },
      paddingTop() {
        return this.internal_config.paddingTopContainer;
      },
      paddingLeft() {
        return this.internal_config.paddingLeftContainer;
      },
      paddingRight() {
        return this.internal_config.paddingRightContainer;
      },
      paddingBottom() {
        return this.internal_config.paddingBottomContainer;
      },
      boxShadow() {
        return this.internal_config.boxShadow;
      },
      border() {
        return this.internal_config.border;
      },
      height() {
        return parseInt(this.internal_config.height) - parseInt(this.internal_config.heightTop) + 'px';
      },
      heightTop() {
        return this.internal_config.heightTop;
      },
      heightTopImg() {
        return parseInt(this.internal_config.heightTop) - 5 + 'px';
      },
      radius() {
        return this.internal_config.borderRadius;
      },
      // bg-color bg-image position/bg-size bg-repeat bg-origin
      background() {
        let bg = this.internal_config.backgroundColor;

        if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {

          bg += ' url("' + this.internal_config.backgroundImage + '")';
          bg += ' ' + this.internal_config.backgroundPosition;
          bg += ' / ' + this.internal_config.backgroundSize;
          bg += ' ' + this.internal_config.backgroundRepeat;
          bg += ' ' + this.internal_config.backgroundOrigin;
        }

        return bg;
      }

    },
    data() {
      return Data.data();
    },
    watch: {
      'internal_config': {
        deep: true,
        handler(value) {
          this.$eventHub.setValueElementConfig(this.id, value);
          this.$eventPointer.log(this.id, value);
        }
      }
    },
    methods: {
      textStyle() {
        return `font-family:  ${this.internal_config.textStyle.family};
                 font-size: ${this.internal_config.textStyle.size};
                 text-align: ${this.internal_config.textStyle.align};
                 font-weight: ${this.internal_config.textStyle.weight};
                 font-style: ${this.internal_config.textStyle.style};
                 text-decoration: ${this.internal_config.textStyle.stroke};
                 border-bottom: ${this.internal_config.borderCategory};
                 margin-bottom: 10px;
                 color: ${this.internal_config.textStyle.color}`;
      },
      widthItem(childs) {
        if (!this.showArrow(childs)) {
          return (parseInt(this.internal_config.width) / (Object.keys(childs).length)) + 'px';
        }
        let amountOfNews = this.internal_config.amountOfNews;
        return (parseInt(this.internal_config.width) / (amountOfNews)) + 'px';
      },
      showArrow(childs) {
        if (this.$props.device !== 'desktop') {
          return true;
        }

        return parseInt(this.internal_config.amountOfNews) <= Object.keys(childs).length - 1;
      },
      prev(index) {
        let thisEl = $(this.$el).find('.carrousel-' + index).find('.item.active');

        let prev = $(thisEl).prev();
        if (!prev.length) {
          prev = $(thisEl).siblings(':last');
        }

        thisEl.removeClass('active');
        prev.addClass('active');
      },
      next(index) {

        let thisEl = $(this.$el).find('.carrousel-' + index).find('.item.active');

        let next = $(thisEl).next();
        if (!next.length) {
          next = $(thisEl).siblings(':first');
        }

        thisEl.removeClass('active');
        next.addClass('active');

      },
      showVideo(id) {

        $("iframe").each(function () {
          let src = $(this).attr('src') || $(this).attr('data-src');
          $(this).attr('src', src);
        });

        $('[element="VideoGalleryComponent"]').hide();
        let element = $('#' + id);
        element.show();
        element.parent().parent().show();
      },

      getDataVideo(id) {
        let tree = this.internal_config.tree;

        for (let i in tree) {
          let childs = tree[i]['childs'];
          for (let j in childs) {
            if (childs[j]['id'] == id) {
              return childs[j];
            }
          }
        }
      },
      changeOrderPanel(elem, idx) {
        let id = elem.$el.id,
          sibling = idx === 1 ? document.getElementById(id).nextSibling : document.getElementById(id).previousSibling;

        if (sibling === null) {
          return true;
        }

        this.$root.$emit('changeOrderElementsInside', this.id, id, sibling.id, idx);
      },
      onResize(x, y, width, height) {
        this.internal_config.width = width + 'px';
        this.internal_config.height = height + 'px';

        let amountOfNews = this.internal_config.amountOfNews;
        let valueWidth = (parseInt(this.internal_config.width) / (amountOfNews)) + 'px';

        $(this.$el).find('.place-img').css({'max-width': valueWidth})


        this.$refs.resourcesData.setValuesData(this);
      },

      resize() {
        let amountOfNews = this.internal_config.amountOfNews;
        let valueWidth = (parseInt(this.internal_config.width) / (amountOfNews)) + 'px';

        $(this.$el).find('.place-img').css({'max-width': valueWidth})

      },

      animation() {
        return false;
      },

      focusElement(e) {
        this.$root.$emit('focusElement', this);
        this.$root.$emit('handlerElement', this);

        e.stopPropagation();
        e.preventDefault();
      },
      handler: function (e) {
        this.$root.$emit('focusElement', this);
        this.$root.$emit('handlerElement', this, true);

        e.stopPropagation();
        e.preventDefault();
      },
      showResources() {
        return this.$refs.resourcesData.getValuesData();
      },
      style() {
        return `left:  ${this.internal_config.left};
                top: ${this.internal_config.top};
				        padding-top: ${this.internal_config.paddingTop};
                padding-left: ${this.internal_config.paddingLeft};
                padding-right: ${this.internal_config.paddingRight};
                padding-bottom: ${this.internal_config.paddingBottom};
                z-index: ${this.internal_config.zIndex};
                width: ${this.internal_config.width};
                max-width: ${this.internal_config.maxWidth};
                margin: 0 auto;`;
      },
      styleApp() {
        return `left:  ${this.internal_config.paddingLeftContainer};
                top: ${this.internal_config.paddingTopContainer};
                display:none;
                width: calc(100% - ${parseInt(this.internal_config.paddingRightContainer) * 2}px !important;
                height: calc(100% - ${parseInt(this.internal_config.paddingBottomContainer) * 2}px !important;`;
      },
      setCallbackChangeDevice(values) {
        this.$emit('setCallbackChangeDevice', values);
      },
      checkVideoApp: function () {
        let vm = this;
        let tree = this.internal_config.tree;

        for (let i in tree) {
          let childs = tree[i]['childs'];
          for (let j in childs) {
            if (childs[j]['id'] === '') {
              this.$root.$emit('createBaseElement', 'VideoGalleryComponent', {}, this.id, (value) => {
                vm.internal_config.tree[i]['childs'][j]['id'] = value;
              });
            }
          }
        }
      },
      saveAll(config) {

        this.config = {};
        this.internal_config = {};

        this.$nextTick(() => {
          this.config = Object.assign({}, this.internal_config, config);
          this.internal_config = Object.assign({}, this.internal_config, config);
          this.$nextTick(() => {
            this.build();
          })
        })
      },
      openEdition() {

        this.$root.$emit('openGalleryVideoModal', this.internal_config, 'fields', this.saveAll);

      },
      setNewColor(colorValue) {
        for (let i in this.elements) {
          if (this.elements[i].name === 'VideoGalleryComponent') {
            this.$root.$emit('changeVideoColor', this.elements[i].id, colorValue);
          }
        }

      },
      warning() {
        return true
      },
      build() {
        this.checkVideoApp();

        //3-6
        let amountOfNews = this.internal_config.amountOfNews;
        let vm = this;

        setTimeout(() => {

          $(vm.$el).find('.carousel-inner').each((i, el) => {

            let lengthCarousel = $(el).find('.item').length;

            if (amountOfNews < lengthCarousel) {
              $(el).parent().carousel({
                interval: 10000
              })
            }

            let countItems = amountOfNews
            if ($(el).find('.item').length < amountOfNews) {
              countItems = $(el).find('.item').length;
            }

            $(el).find('.item').each((j, elItem) => {

              let next = $(elItem).next();
              if (!next.length) {
                next = $(elItem).siblings(':first');
              }
              next.children(':first-child').clone().appendTo($(elItem));

              for (let i = 0; i < (countItems - 2); i++) {
                next = next.next();
                if (!next.length) {
                  next = $(elItem).siblings(':first');
                }

                next.children(':first-child').clone().appendTo($(elItem));
              }
            });
          });

          $(vm.$el).find('.container-gallery-video').hide();
          $(vm.$el).find('.container-gallery-video').addClass('container-gallery-video-hide');

          $('.element-item').on('click', (e) => {
            $(vm.$el).find('.container-gallery-video').hide();
            $(vm.$el).find('.container-gallery-video').addClass('container-gallery-video-hide');
            vm.showVideo(e.currentTarget.getAttribute('data-id'))
          })

        }, 3000);

      },
      sendNewChilds() {

        let vm = this;

        setTimeout(() => {
          vm.$eventPointer.changePointerState(true);
          vm.$eventPointer.logChilds(vm.id, vm.elements);
          setTimeout(() => {
            vm.$eventPointer.changePointerState(true);
          }, 500)
        }, 1000)
      },
    },
    created() {
      this.keyComponent = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);

      let internal_config = window.mergeRecursive(this.props, this.$props.config);
      this.internal_config = {...internal_config, ...this.internal_config};

    },
    mounted() {
      let device, childs, id, config;
      ({device, childs, id, config} = this.$props);

      if (typeof config.backgroundColor === 'undefined') {
        config.backgroundColor = '#FFFFFF';
      }
      this.internal_config = config;
      this.device = device;

      if (typeof childs === 'undefined') {
        childs = [];
        this.internal_config.childs = [];
      }

      if (typeof id !== 'undefined') {
        this.id = id;
      }

      let objIds = [];
      $('[id]').each(function () {
        var ids = $('[id="' + this.id + '"]');
        if (ids.length > 1 && ids[0] == this && parseInt(this.id)) {
          objIds.push(this.id)
        }
      });

      if (objIds.includes(this.id)) {
        let newId = Date.now() + parseInt(Math.random() * 10000);
        this.id = newId;

        childs.forEach((el, index) => {
          try {
            childs[index].config.parent_id = newId;
          } catch (e) {
          }
        });

        this.$refs.elem.id = newId;
      }

      this.elements = childs.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));

      let achou = true;
      let arrayOnlyVideo = [];
      for (let index in this.elements) {
        if (this.elements[index].name === 'VideoGalleryComponent') {

          arrayOnlyVideo.push(JSON.parse(JSON.stringify(this.elements[index])));

          for (let j in this.internal_config.tree) {

            for (let i in this.internal_config.tree[j].childs) {

              if (this.internal_config.tree[j].childs[i].id === this.elements[index].id) {
                achou = true;
              } else {
                achou = false;
              }
            }
          }
        }
      }

      if (!achou) {
        let idc = 0;
        for (let j in this.internal_config.tree) {

          for (let i in this.internal_config.tree[j].childs) {
            this.internal_config.tree[j].childs[i].id = arrayOnlyVideo[idc++].id;
          }
        }
      }

      // this.internal_config = window.mergeRecursive(this.props, this.$props.config);
      let internal_config = window.mergeRecursive(this.props, this.$props.config);
      this.internal_config = {...internal_config, ...this.internal_config};

      this.$root.$on('setConfigElement', (id, obj) => {
        if (this.id == id) {
          this.config = obj;
          this.internal_config = obj;
        }
      });

      this.$root.$on('removeGalleryVideo', (id) => {
        let tree = this.internal_config.tree;

        for (let i in tree) {
          let childs = tree[i]['childs'];
          for (let j in childs) {
            if (childs[j]['id'] == id) {
              this.internal_config.tree[i]['childs'].splice(j);
            }
          }
        }
      });

      this.$root.$on('setChildsObj', (id) => {
        if (this.id == id) {

          this.$eventPointer.logChilds(this.id, this.elements);

          let childsHub = this.$eventHub.getChilds(this.id);

          this.config.childs = childsHub;
          this.internal_config.childs = childsHub;

          this.elements = {};
          this.$nextTick(() => {
            this.elements = childsHub.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));
            this.componentKey += 1;

            this.$nextTick(() => {
              this.sendNewChilds();
              this.$root.$emit('activeSort');
              this.$refs.resourcesData.setValuesData(this);
            });
          });
        }
      });

      this.$root.$on('setChildsUndoRedo', (id, childs) => {
        if (this.id == id) {
          this.$eventHub.setChilds(this.id, childs);

          this.config.childs = childs;
          this.internal_config.childs = childs;

          this.elements = {};
          this.$nextTick(() => {
            this.elements = childs.sort((a, b) => (a.config.order_mobile > b.config.order_mobile) ? 1 : ((b.config.order_mobile > a.config.order_mobile) ? -1 : 0));
            this.componentKey += 1;
          });
        }
      });

      this.build();

      this.$refs.resourcesData.setValuesData(this);
    }
  };

</script>
<style lang="scss" scoped>


  .sitebuilder-element-container {
    .vdr {
      height: unset !important;

    }
  }

  .container-gallery-video {
    position: relative;

    .container-gallery-video-hide {
      display: none;
    }
  }

  [data-device="tablet"] {
    iframe.video-margin {
      height: 425px;
    }
  }

  [data-device="mobile"],
  [data-device="tablet"] {
    .container-gallery-video {
      height: auto !important;
    }

    .row-gallery {
      display: block;
    }

    .col-gallery {
      display: table-cell;

      .embed-responsive-item {
        max-width: 100% !important;
      }
    }
  }

  [data-preview="true"] {
    .container-gallery-video {
      overflow: hidden;
    }
  }

  img.place-img {
    margin-left: 5px;
  }

  [element="VideoGalleryGroupComponent"] {
    .carousel-inner {
      .item.active {
        display: inline-flex;
      }
    }

    .carousel-control {
      width: 20px;
      text-align: center;
      vertical-align: middle;
      background: none;

      display: flex; /*CSS3*/
      align-items: center; /*Vertical align*/
      justify-content: center; /*horizontal align*/
    }

    .carousel-control.right {
      right: -20px;
    }

    .carousel-control.left {
      left: -20px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/VideoGallery/Gallery/Gallery.vue